import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UserWidgetsService {
  private refresh$ = new Subject<void>();

  /** Emits when user widgets have been updated (e.g. after Apply in My Widgets slider) */
  readonly onWidgetsUpdated = this.refresh$.asObservable();

  /** Call after successfully updating user widgets to refresh the dashboard */
  notifyWidgetsUpdated(): void {
    this.refresh$.next();
  }
}
